class BundleCheck extends HTMLElement {
  constructor(){
    super();
    this.id = this.dataset.pid;
    this.querySelector('button').setAttribute("disabled", true);
    this.querySelector('button').style.cursor = 'not-allowed'
    this.getCartItems();
    document.addEventListener('cartUpdate',()=>{ this.getCartItems(true) })
    
  }

  // store line_item product id in session
  async getCartItems(update){
    let forceUpdate  = window.location.href.includes("collection") || window.location.href.includes("/") || update ;
    let cartItem = sessionStorage.getItem('cart-Items');
    let maximumQty = this.dataset.maxQuantity;
    let productId = this.id;

    let quantity = false
    if( !cartItem || forceUpdate ){
      await fetch('/cart.js').then((res)=> res.json()).then((data)=> {
        let cartItems = data.items.map((item)=> ({id: item.product_id, quantity: item.quantity}));
        sessionStorage.setItem('cart-Items',JSON.stringify(cartItems))
        this.check();
      });
    }
  }

  // check and update the status
  check(){
    let productId = this.dataset.pid;
    let maximumQty = this.dataset.maxQuantity;
    let collectionMaxQty = this.dataset.collectionMaxQuantity
    let isBundel = this.dataset.bundel
    let collectionBundel = this.dataset.collectionBundel

    let cartData = JSON.parse(sessionStorage.getItem('cart-Items'));
    let productCurrentQuantity = cartData.find(item => item.id == productId)?.quantity;

    if(isBundel =='true' && productCurrentQuantity >= parseInt(maximumQty)){
      this.querySelector('button').setAttribute("disabled", true);
      this.querySelector('button').innerHTML = "Added to cart";
      this.querySelector('button').style.cursor = "not-allowed";
    } else if(collectionBundel =='true' && productCurrentQuantity >= parseInt(collectionMaxQty)) {
      this.querySelector('button').setAttribute("disabled", true);
      this.querySelector('button').innerHTML = "Added to cart";
      this.querySelector('button').style.cursor = "not-allowed";
    }
    else{
      this.querySelector('button').removeAttribute("disabled");
      this.querySelector('button').innerHTML = "Add to cart <sup>+</sup>";
      this.querySelector('button').style.cursor = "pointer";
    }
  }

  update(){
    this.getCartItems(true)
  }
}

customElements.define('mm-bundle-check',BundleCheck);
